import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TipoActividadPrincipal } from 'src/app/models/enum/tipo-actividad-principal.enum';
import { TipoCarrera } from 'src/app/models/enum/tipo-carrera.enum';
import { TipoNivelEstudios } from 'src/app/models/enum/tipo-nivel-estudios.enum';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { PersonaService } from 'src/app/services/persona.service';
import { StepperService } from 'src/app/services/stepper.service';

@Component({
  selector: 'app-antecedentes-ocupacionales',
  templateUrl: './antecedentes-ocupacionales.component.html',
  styleUrls: ['./antecedentes-ocupacionales.component.css']
})
export class AntecedentesOcupacionalesComponent implements OnInit {
  antecedentesForm: FormGroup = new FormGroup({});
  tiposNivelEstudios : TipoNivelEstudios | any = TipoNivelEstudios;
  tiposCarrera : TipoCarrera | any = TipoCarrera;
  tiposActividadPrincipal : TipoActividadPrincipal | any = TipoActividadPrincipal;
  private persona : any;
  hoy: string = '';

  constructor(private fb: FormBuilder, private stepperService : StepperService, private dataService: DataService, private personaService: PersonaService,
    private commonService: CommonService) {

      this.antecedentesForm = this.fb.group({
        guid: new FormControl(null),
        esCargoPublico: new FormControl(false),
        familiarCargoPublico: new FormControl(false),
        institucionPublico: new FormControl(''),
        cargoPublico: new FormControl(''),
        tipoActividadPrincipal: new FormControl(null, [Validators.required]),
        otroTipoActividadPrincipal: new FormControl('', [Validators.required]),
        profesionCarrera: new FormControl('', [Validators.required, Validators.pattern('^[A-Za-zÁáÉéÍíÓóÚúÜüÑñ ]+$')]),
        tipoCarrera: new FormControl(null, [Validators.required]),
        duracionCarrera: new FormControl(null, [Validators.required]),
        anoActualCarrera: new FormControl(null, [Validators.required]),
        tipoNivelEstudios: new FormControl(null, [Validators.required]),
        institucionEducacional: new FormControl('', [Validators.required]),
        nombreEmpleador: new FormControl('', [Validators.required, Validators.pattern('^[A-Za-zÁáÉéÍíÓóÚúÜüÑñ ]+$')]),
        rutEmpleado: new FormControl('', [Validators.required, Validators.pattern(/^[1-9]\d*[-|‐]{1}[0-9kK]{1}$/), this.commonService.createRutValidator()]),
        socio: new FormControl(false),
        sostenedorEconomico: this.fb.group({
          guid: new FormControl(null),
          rut: new FormControl('', [Validators.required, Validators.pattern(/^[1-9]\d*[-|‐]{1}[0-9kK]{1}$/), this.commonService.createRutValidator()]),
          apellidoPaterno: new FormControl('', [Validators.required, Validators.pattern('^[A-Za-zÁáÉéÍíÓóÚúÜüÑñ ]+$')]),
          apellidoMaterno: new FormControl('', [Validators.required, Validators.pattern('^[A-Za-zÁáÉéÍíÓóÚúÜüÑñ ]+$')]),
          nombre: new FormControl('', [Validators.required, Validators.pattern('^[A-Za-zÁáÉéÍíÓóÚúÜüÑñ ]+$')]),
          direccion: new FormControl('', [Validators.required]),
          actividad: new FormControl('', [Validators.required])
        }),
        cargoActividad: new FormControl('', [Validators.required]),
        fechaInicio: new FormControl(null, [Validators.required]),
        sueldo: new FormControl(null),
        honorarios: new FormControl(null),
        retiros: new FormControl(null),
        arriendos: new FormControl(null),
        otros: new FormControl(null),
        totalIngresos: new FormControl(null, [Validators.required])
      });

  }

  ngOnInit(): void {
    const today = new Date();
    this.hoy = today.toISOString().split('T')[0];
    this.personaService.persona$.subscribe({
      next: (persona) => {
        if (persona) {
          this.persona = persona;
          this.commonService.setFormGroupValues(this.antecedentesForm, persona.estadoSituacion.personaAntecendesOcupacionales);
          this.nivelEstudiosChange(persona.estadoSituacion?.personaAntecendesOcupacionales?.tipoNivelEstudios);
          this.cambioEsCargoPublico(persona.estadoSituacion?.personaAntecendesOcupacionales?.esCargoPublico);
          this.cambioEsCargoPublico(persona.estadoSituacion?.personaAntecendesOcupacionales?.familiarCargoPublico);
          this.actividadPrincipalChange(persona.estadoSituacion?.personaAntecendesOcupacionales?.tipoActividadPrincipal);
          this.tipoCarreraChange(persona.estadoSituacion?.personaAntecendesOcupacionales?.tipoCarrera);
          this.sumaIngresos();
          if (persona.estadoSituacion?.estadoFormularioSituacion == 'Firmado') {
            this.antecedentesForm.disable();
          }
        }
      }
    });

    this.antecedentesForm.get('institucionPublico')?.disable();
    this.antecedentesForm.get('cargoPublico')?.disable();
    this.antecedentesForm.get('otroTipoActividadPrincipal')?.disable();
    this.antecedentesForm.get('sostenedorEconomico')?.disable();
    this.antecedentesForm.get('nombreEmpleador')?.disable();
    this.antecedentesForm.get('rutEmpleado')?.disable();
    this.antecedentesForm.get('socio')?.disable();
    this.antecedentesForm.get('cargoActividad')?.disable();
    this.antecedentesForm.get('fechaInicio')?.disable();
    this.antecedentesForm.get('tipoCarrera')?.disable();
    this.antecedentesForm.get('duracionCarrera')?.disable();
    this.antecedentesForm.get('anoActualCarrera')?.disable();
    this.antecedentesForm.get('institucionEducacional')?.disable();
  }

  onSubmit() {
    if(this.persona.estadoSituacion?.estadoFormularioSituacion == 'Firmado'){
      if(this.persona.identificacionPersona.tipoEstadoCivil != 'Casado' && this.persona.identificacionPersona.tipoEstadoCivil != 'ConvivienteCivil'){
        this.stepperService.setStepIndex(5);
      }
      else{
        this.stepperService.nextStep();
      }
    }
    if(!this.antecedentesForm.invalid) {
      this. removeNullGuid();
      const formData = this.antecedentesForm.getRawValue();
      const guidAntecedentesOcupacionales = this.persona.estadoSituacion?.personaAntecendesOcupacionales?.guid;
      const guidSostenedor = this.persona.estadoSituacion?.personaAntecendesOcupacionales?.sostenedorEconomico?.guid;

      if (guidAntecedentesOcupacionales) {
        formData.guid = guidAntecedentesOcupacionales;
      }
      if (guidSostenedor) {
        formData.sostenedorEconomico.guid = guidSostenedor;
      }

      var url = `estado-situacion/${this.personaService.getPersonaGuid()}/antecedentes-ocupacionales`;
      this.dataService.postData(formData, url).subscribe({
        next: (v) => {
          if(this.persona.identificacionPersona.tipoEstadoCivil != 'Casado' && this.persona.identificacionPersona.tipoEstadoCivil != 'ConvivienteCivil'){
            this.stepperService.setStepIndex(5);
          }
          else{
            this.stepperService.nextStep();
          }
        },
        error: (e) => console.log(e),
        complete: () => {
          this.personaService.setPersona();
        },
      });
    }else{
      console.log(this.antecedentesForm);
      this.antecedentesForm.markAllAsTouched();
    }
  }

  sumaIngresos(){
    var sueldo = this.antecedentesForm.get('sueldo')?.getRawValue();
    var honorarios = this.antecedentesForm.get('honorarios')?.getRawValue();
    var retiros = this.antecedentesForm.get('retiros')?.getRawValue();
    var arriendos = this.antecedentesForm.get('arriendos')?.getRawValue();
    var otros = this.antecedentesForm.get('otros')?.getRawValue();
    
    var totalIngresos = sueldo + honorarios + retiros + arriendos + otros;
    if (totalIngresos === 0) {
      totalIngresos = null;
    }
    this.antecedentesForm.get('totalIngresos')?.setValue(totalIngresos);
  }

  nivelEstudiosChange(event: any){
    if(event == "EducacionBasica" || event == "EducacionMedia" || event == null){
      this.antecedentesForm.get('tipoCarrera')?.setValue(null);
      this.antecedentesForm.get('duracionCarrera')?.setValue(null);
      this.antecedentesForm.get('anoActualCarrera')?.setValue(null);
      this.antecedentesForm.get('institucionEducacional')?.setValue(null);
      this.antecedentesForm.get('tipoCarrera')?.disable();
      this.antecedentesForm.get('duracionCarrera')?.disable();
      this.antecedentesForm.get('anoActualCarrera')?.disable();
      this.antecedentesForm.get('institucionEducacional')?.disable();
    }else{
      this.antecedentesForm.get('tipoCarrera')?.enable();
      this.antecedentesForm.get('duracionCarrera')?.enable();
      this.antecedentesForm.get('anoActualCarrera')?.enable();
      this.antecedentesForm.get('institucionEducacional')?.enable();
    }
  }

  tipoCarreraChange(event: any){
    if(event != "Incompleta"){
      this.antecedentesForm.get('anoActualCarrera')?.setValue(null);
      this.antecedentesForm.get('anoActualCarrera')?.disable();
    }else{
      this.antecedentesForm.get('anoActualCarrera')?.enable();
    }
  }

  cambioEsCargoPublico(event: any){
    if((event != undefined && event.checked )|| this.antecedentesForm.get('esCargoPublico')?.value || this.antecedentesForm.get('familiarCargoPublico')?.value){
      this.antecedentesForm.get('institucionPublico')?.enable();
      this.antecedentesForm.get('cargoPublico')?.enable();
    }else{
      this.antecedentesForm.get('institucionPublico')?.disable();
      this.antecedentesForm.get('institucionPublico')?.setValue(null);
      this.antecedentesForm.get('cargoPublico')?.disable();
      this.antecedentesForm.get('cargoPublico')?.setValue(null);
    }
  }

  actividadPrincipalChange(event: any){
    if(event == "Estudiante" || event == "Desempleado" || event == "DuenaDeCasa"){
      this.antecedentesForm.get('sueldo')?.clearValidators();
      this.antecedentesForm.get('honorarios')?.clearValidators();
      this.antecedentesForm.get('retiros')?.clearValidators();
      this.antecedentesForm.get('arriendos')?.clearValidators();
      this.antecedentesForm.get('otros')?.clearValidators();
      this.antecedentesForm.get('totalIngresos')?.clearValidators();
    }else{
      this.antecedentesForm.get('totalIngresos')?.setValidators([Validators.required]);
    }
    if(event=="Independiente"){
      this.antecedentesForm.get('honorarios')?.setValidators([Validators.required]);
    }else{
      this.antecedentesForm.get('honorarios')?.clearValidators();
    }
    if(event=="Dependiente" || event=="FuerzasArmadas"){
      this.antecedentesForm.get('sueldo')?.setValidators([Validators.required]);
    }else{
      this.antecedentesForm.get('sueldo')?.clearValidators();
    }
    if(event=="Rentista"){
      this.antecedentesForm.get('arriendos')?.setValidators([Validators.required]);
    }else{
      this.antecedentesForm.get('arriendos')?.clearValidators();
    }
    if(event=="Jubilado"){
      this.antecedentesForm.get('retiros')?.setValidators([Validators.required]);
    }else{
      this.antecedentesForm.get('retiros')?.clearValidators();
    }
    if (event=="Otros" || event== "SocioDeEmpresa"){
      this.antecedentesForm.get('otros')?.setValidators([Validators.required]);
    }else{
      this.antecedentesForm.get('otros')?.clearValidators();
    }

    this.antecedentesForm.get('sueldo')?.updateValueAndValidity();
    this.antecedentesForm.get('honorarios')?.updateValueAndValidity();
    this.antecedentesForm.get('retiros')?.updateValueAndValidity();
    this.antecedentesForm.get('arriendos')?.updateValueAndValidity();
    this.antecedentesForm.get('otros')?.updateValueAndValidity();
    this.antecedentesForm.get('totalIngresos')?.updateValueAndValidity();


    if(event == "Otros"){
      this.antecedentesForm.get('otroTipoActividadPrincipal')?.enable();
    }else{
      this.antecedentesForm.get('otroTipoActividadPrincipal')?.setValue('');
      this.antecedentesForm.get('otroTipoActividadPrincipal')?.disable();
    } 

    if(event == "Estudiante" || event == "DuenaDeCasa"){
      this.antecedentesForm.get('sostenedorEconomico')?.enable();
    }else{
      this.antecedentesForm.get('sostenedorEconomico')?.disable();
      this.antecedentesForm.get('sostenedorEconomico')?.reset();
    }
    
    if(event == "Dependiente" || event == "Independiente"){
      this.antecedentesForm.get('nombreEmpleador')?.enable();
      this.antecedentesForm.get('rutEmpleado')?.enable();
      this.antecedentesForm.get('socio')?.enable();
      this.antecedentesForm.get('cargoActividad')?.enable();
      this.antecedentesForm.get('fechaInicio')?.enable();
    }else{
      this.antecedentesForm.get('nombreEmpleador')?.setValue('');
      this.antecedentesForm.get('rutEmpleado')?.setValue('');
      this.antecedentesForm.get('socio')?.setValue(false);
      this.antecedentesForm.get('cargoActividad')?.setValue('');
      this.antecedentesForm.get('fechaInicio')?.setValue(null);
      this.antecedentesForm.get('nombreEmpleador')?.disable();
      this.antecedentesForm.get('rutEmpleado')?.disable();
      this.antecedentesForm.get('socio')?.disable();
      this.antecedentesForm.get('cargoActividad')?.disable();
      this.antecedentesForm.get('fechaInicio')?.disable();
    }
  }

  getTipoActividadPrincipalKeys(): string[] {
    const sortedKeys = Object.keys(TipoActividadPrincipal).sort();
    const otrosIndex = sortedKeys.indexOf('Otros');
  
    if (otrosIndex > -1) {
      sortedKeys.splice(otrosIndex, 1); // Eliminar "Otros" de su posición actual
      sortedKeys.push('Otros'); // Agregar "Otros" al final
    }
  
    return sortedKeys;
  }

  getTipoCarreraKeys(): string[] {
    return Object.keys(TipoCarrera).sort();
  }

  getTipoNivelEstudiosKeys(): string[] {
    return Object.keys(TipoNivelEstudios).sort();
  }

  volver(){
    this.stepperService.prevStep();
  }

  removeNullGuid() {
      if(this.antecedentesForm.get('guid')?.value == null) {
        this.antecedentesForm.removeControl('guid');
      }
      if(this.antecedentesForm.get('sostenedorEconomico')?.get('guid')?.value == null){
        const sostenedorEconomicoGroup = this.antecedentesForm.get('sostenedorEconomico') as FormGroup;
        sostenedorEconomicoGroup.removeControl('guid');
      }
    }

}